import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';

import GaleriaBetahealth from '../../Components/Galerias/Betahealth';

import betahealth1 from '../../Images/Proyectos/betahealth.png';
import betahealth2 from '../../Images/Proyectos/Galerias/Betahealth/4.png';
import betahealth3 from '../../Images/Proyectos/Galerias/Betahealth/5.png';


const Betahealth = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
      <Fragment>

        <img className="center-img dimensionar-imagen-movil" alt="" src={betahealth1}></img>

        <div className='container'>
          {window.screen.width >= 993 ? (
            <p className='texto' style={{textAlign:"center"}}>
              Esta empresa establecida en Chicago, Illinois está enfocada en la innovación <br />
              de las medicinas y terapias más avanzadas para diversas enfermedades tales como <br />
              injerto de cartílago o COVID-19. <br /><br />
              Para ellos desarrollamos una landing page con toda su información y productos, <br />
              así como un gran sistema empresarial (web y escritorio) para facilitar <br />
              los procesos internos de la empresa. <br /><br />
              El sistema cuenta con diversos perfiles tales como: ventas, finanzas, inventario, chats, <br />
              seguimiento a pacientes, traqueo de envíos y la administración general de la empresa <br />
              para tener control total de cada una de las acciones necesarias <br />
              para que continúen ofreciendo el mejor servicio.
            </p>
          ) :(
            <p className='texto' style={{textAlign:"center"}}>
              Esta empresa establecida en Chicago, Illinois está enfocada en la innovación 
              de las medicinas y terapias más avanzadas para diversas enfermedades tales como 
              injerto de cartílago o COVID-19. <br /><br />
              Para ellos desarrollamos una landing page con toda su información y productos, 
              así como un gran sistema empresarial (web y escritorio) para facilitar 
              los procesos internos de la empresa. <br /><br />
              El sistema cuenta con diversos perfiles tales como: ventas, finanzas, inventario, chats, 
              seguimiento a pacientes, traqueo de envíos y la administración general de la empresa 
              para tener control total de cada una de las acciones necesarias 
              para que continúen ofreciendo el mejor servicio. 
            </p>
          )}
        </div>

        <div className='container'>
          <GaleriaBetahealth/>
        </div>

        <div className='dimensionar-imagen-beta'>
          <img className="center-img" alt="" src={betahealth2}></img>
          <img className="center-img" alt="" src={betahealth3}></img>
        </div>

        <div style={{display:"flex", justifyContent:"center", margin:"50px"}}>
          <div className='btn_1'>
            <a href="#portafolioSofwareOver" style={{color:"#fff"}}>
              <p>
                Ver más del portafolio
              </p>
            </a>
          </div>
        </div>
        
      </Fragment>
    );
}

export default Betahealth;
